export const CUSTOMERS_INTENT_TEMPLATES = {
  CREATE_CUSTOMER: {
    label: "Create Customer",
    pendingTitle: "Create customer",
    summary: (payload: Record<string, unknown>) => {
      const firstName = typeof payload.firstName === "string" ? payload.firstName : "";
      const lastName = typeof payload.lastName === "string" ? payload.lastName : "";
      const name = `${firstName} ${lastName}`.trim();
      return name.length > 0 ? `Create new customer: ${name}` : "Create new customer";
    },
    fieldLabels: {
      firstName: "First name",
      lastName: "Last name",
      email: "Email",
      phone: "Phone",
      notes: "Notes",
    },
  },
} as const;
